// extracted by mini-css-extract-plugin
export default {"row":"MaterialMemberArea_row__7glb6"};